import { useCallback, useState } from "react";

import EmployeeEmploymentInfo from "../pages/EmployeeEmploymentInfo";
import EmployeeEmploymentMovement from "../pages/EmployeeEmploymentMovement";
import EmployeeEmploymentOrganizationStructure from "../pages/EmployeeEmploymentOrganizationStructure";
import EmployeeEmploymentShift from "../pages/EmployeeEmploymentShift";
import EmployeeEmploymentSubordinates from "../pages/EmployeeEmploymentSubordinates";
import EmployeeEmploymentSupervisor from "../pages/EmployeeEmploymentSupervisor";

import { EMPLOYEE_EMPLOYMENT_PAGE } from "../schemas/employeeEmploymentSchema";

function useEmployeeEmployment() {
  const [selectedMenu, setMenu] = useState(
    EMPLOYEE_EMPLOYMENT_PAGE.EMPLOYMENT_INFO
  );

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case EMPLOYEE_EMPLOYMENT_PAGE.EMPLOYMENT_INFO:
        return <EmployeeEmploymentInfo />;
      case EMPLOYEE_EMPLOYMENT_PAGE.SHIFT_INFO:
        return <EmployeeEmploymentShift />;
      case EMPLOYEE_EMPLOYMENT_PAGE.SUBORDINATES:
        return <EmployeeEmploymentSubordinates />;
      case EMPLOYEE_EMPLOYMENT_PAGE.SUPERVISOR:
        return <EmployeeEmploymentSupervisor />;
      case EMPLOYEE_EMPLOYMENT_PAGE.ORGANIZATION_STRUCTURE:
        return <EmployeeEmploymentOrganizationStructure />;
      case EMPLOYEE_EMPLOYMENT_PAGE.MOVEMENT:
        return <EmployeeEmploymentMovement />;
      default:
        return <div />;
    }
  }, [selectedMenu]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  return { getPage, handleMenuChange };
}

export default useEmployeeEmployment;
